import _defineProperty from "C:/Users/byron/Development/makeripples/platform/gatsby-sales/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { cssVar } from "@chakra-ui/theme-tools";
var $size = cssVar("spinner-size");
var baseStyle = {
  width: [$size.reference],
  height: [$size.reference]
};
var sizes = {
  xs: _defineProperty({}, $size.variable, "0.75rem"),
  sm: _defineProperty({}, $size.variable, "1rem"),
  md: _defineProperty({}, $size.variable, "1.5rem"),
  lg: _defineProperty({}, $size.variable, "2rem"),
  xl: _defineProperty({}, $size.variable, "3rem")
};
var defaultProps = {
  size: "md"
};
export default {
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};